import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SignupForm } from '../../components/signup-form/signup-form';

@Component({
  selector: 'app-signup',
  imports: [CommonModule, SignupForm],
  templateUrl: './signup.html',
  styleUrl: './signup.scss',
})
export class Signup {}
